import React, {Component} from 'react';
import PropTypes from 'prop-types';
import FullCalendar from 'fullcalendar-reactwrapper';
import 'react-big-calendar/lib/less/month.less'
import '../../../assets/css/react-big-calendar.css'
import 'react-big-calendar/lib/less/styles.less'
import $ from "jquery";
import Modal from 'react-modal';
import {MONTH,currency_symbol, URL_VERSION} from "../../../server/constants";
import EmailSelect from '../../SchoolAdmin/ManagePayments/EmailSelect'
import {postWithHeaders} from "../../../server/actionsParent";
import {postWithHeadersResponse} from "../../../server/actions";
import {BeatLoader} from 'react-spinners';
import NotificationSystem from 'react-notification-system';
import InstantPayment from './instantPayment';
import {_addNotification, _addNotificationError, convertTwoDecimalPoint} from '../../../server/util'

let _studentIsFreeMeal=false;
let _reducedPriceStatus=false;
let _studentIsReducePrice=false;
const customStyles = {
    content: {
        textAlign: 'justify',
        textJustify: 'inter-word',
        padding: '15px',
        maxHeight: '400px',     
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '40%',
        transform: 'translate(-50%, -50%)'
    }
};
class orderedMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menu: [],
            loading: false,
            reducedPrice: null,
            width: window.innerWidth,
            showEmailSelect:false,
            emailList:[],
            showInstantPayModal:false,
            formData:[]
        }
    }
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;

    }
    closeEmailSelect=()=>{
        this.setState({showEmailSelect:false,emailList:[]})
    }
    openEmailSelect=(e)=>{
        if (sessionStorage.getItem('ROLE') == 'ROLE_ADMIN') {
        /*     let _studentData=Object.assign({},this.props.studentData);
            let _emailIds=[];
            _emailIds.push(_studentData.parentuser.userName);
            if((_studentData.parentuser.parentAltEmail||'').trim().length>0){
                _emailIds.push(_studentData.parentuser.parentAltEmail);
            }
            const uniqueSet = new Set(_emailIds);
            const uniqueEmails = ([...uniqueSet]).map(id=>{
                return {email:id,selected:false}
            })
        if(uniqueEmails.length==1){
            uniqueEmails[0].selected=true
            this.setState({emailList:uniqueEmails},
                this.prepareForSave()) 
        }else{
            if(uniqueEmails.length>1){
                this.setState({showEmailSelect:true,emailList:uniqueEmails})
            }
        } */ 
        this.prepareForSave();
        } else {
            this.prepareForSave()    
        }           
    }
    prepareForSave=()=>{
        let formData = [];
        let body = {}
        body.studentId = this.props.studentData._links.studentUser.href.split('/').pop();
        body.schoolMealIds = [];      
        let emailList=[]
        this.state.emailList.forEach(email=>{
            if(email.selected){
                emailList.push(email.email)
            }
        }); 
        body['parentUserEmails']=emailList.join(',');
        this.state.menu.forEach(meal => {
            if(this.props.isSideSelect){
                if(meal.isSelected){
                    body.schoolMealIds.push(meal.mealCalendarId);
                }
            }else{
                body.schoolMealIds.push(meal.mealCalendarId);
            }
        })
        formData.push(body)
        if(this.props.instantPayment){
            if(sessionStorage.getItem('ROLE')=='ROLE_ADMIN'){
                this.setState({showInstantPayModal:true, formData:formData});
            } else if(sessionStorage.getItem('ROLE')=='ROLE_PARENT'){
                this.setState({showInstantPayModal:true, formData:formData});
            }
        }else{
            this.mealOrder(formData);
        }
    }
    mealOrder = (formData) => {    
        this.setState({loading: true});    
        let headers = {
            'Content-Type': 'application/json'
        }
        let mealMonth = this.props.mealMonth.year + '' + (('0' + this.props.mealMonth.month).slice(-2));
        let loginUserName=(sessionStorage.getItem('ROLE')=='ROLE_ADMIN'?sessionStorage.getItem('loggedUserName'):sessionStorage.getItem('loggedInUserInfo'));
        postWithHeadersResponse(URL_VERSION+'/orderMenu?loggedUser=' + loginUserName + '&yearMonth=' + mealMonth + '&access_token=', JSON.stringify(formData),
            headers).then((response) => {
            if (response.statusCode!==200) {
                throw Error(response.statusMessage);
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if (res.statusCode === 200) {
                sessionStorage.removeItem('Menu')
                sessionStorage.removeItem('Price')
                this.setState({loading: false});
                _addNotification(res.statusMessage, this);
                console.log('response', res);
                setTimeout(() =>
                (sessionStorage.getItem('ROLE')=='ROLE_ADMIN'?
                this.context.router.history.push('/schoolAdmin/viewOrdersGrid')
                : window.location.replace('/parent')), 2000);
            }
        }).catch(
            (error) => {
                this.setState({loading: false});
                _addNotificationError(error.message, this)
                console.log('Meal order Creation Error', error)
            }
        );
    }
    componentWillMount = () => {
        console.log(this.props.studentData)
        console.log(this.props.order)
        _studentIsFreeMeal=this.props.studentIsFreeMeal;
        _studentIsReducePrice=this.props.studentIsReducePrice;
        _reducedPriceStatus=this.props.reducedPriceStatus;
        let selection = [];
        let dates = [];
        let reducedprice = null;
        this.props.order.forEach(order => {
            if (order.isSelected || order.type === "HOLIDAY") {
                dates.push(new Date(order.start).getDate());
                selection.push(order)
                if (this.props.reducedPriceStatus) {
                    reducedprice += order.reducedPrice;
                }
            }
        });
        this.props.order.forEach(order => {
            if (order.type === "SIDE" && dates.indexOf(new Date(order.start).getDate()) > -1) {
                if(this.props.isSideSelect){
                    if(order.isSelected){
                        const idx=selection.findIndex(itm=>{
                            return (order.title==itm.title && order.start.toString() == itm.start.toString())
                        });
                        if(idx===-1){
                            selection.push(order);
                        }                        
                    }
                }else{
                    selection.push(order);
                }    
            }
        })
        this.setState({menu: selection, reducedPrice: reducedprice});
    }  

    eventStyles=(event, element, view)=> {
        if (event.type === "MEAL") {
            return $('<div style="cursor:pointer;height:auto;background-color:inherit;border-radius:25px;' +
                'white-space: pre-wrap;color: black;font-size:13px;padding: 8px 14px;font-weight: bolder;margin-bottom: 5px">'
                + event.title + "  " +currency_symbol() 
                + (_studentIsFreeMeal? 0: (_studentIsReducePrice && _reducedPriceStatus)?event.reducedPrice:  event.price) + '</div>');
        }
        else if (event.type === "SIDE") {
            element.css('background-color', 'inherit');
            element.css('border', '0px');
            element.css('font-weight', 'bolder');
            element.css('white-space', 'pre-wrap');
            element.css('color', 'red');
            element.css('font-size', '12px');
            element.css(' margin-bottom', '-5px');
        }
        if (event.type === "EXTRA") {
            return $('<div style="cursor:pointer;height:auto;background-color:inherit;border-radius:25px;' +
                'white-space: pre-wrap;color: #5cb85c;font-size:13px;padding: 8px 14px;font-weight: bolder;margin-bottom: 5px">E :'
                + event.title + "  " +currency_symbol() 
                +   event.price + '</div>');
        }
        else {
            element.css('background-color', 'inherit');
            element.css('color', 'black');
            element.css('border', '0px');
        }
    }
    adminInstantPaymentSubmit=({lunchBal, paymentObj, _monthYear})=>{
        this.setState({loading: true});  
        let _formData=this.state.formData[0]||{};
        let bal=0.00;
        if(lunchBal.selected){
            _formData['walletAmt']=lunchBal.amount;
            let lBalAmt=paymentObj.balAmount;
            bal=(paymentObj.balAmount>=lunchBal.balAvAmount)?(paymentObj.balAmount-lunchBal.balAvAmount):paymentObj.balAmount
            if(lBalAmt<=0.00){   
                _formData["paymentType"]='Wallet';
                _formData["instantPayAmt"]=0.00;
            }else{
                _formData["paymentType"]=paymentObj.paymentType;
                _formData["instantPayAmt"]=bal;
            }
        }else{
            bal=paymentObj.balAmount;
            _formData['walletAmt']=0.00;
            _formData["paymentType"]=paymentObj.paymentType;
            _formData["instantPayAmt"]=bal;
        }
        
        _formData["checkNum"]=paymentObj.checkNum;
        let headers = {
            'Content-Type': 'application/json'
        }
        let monthYear = _monthYear;
        let loginUserName=(sessionStorage.getItem('ROLE')=='ROLE_ADMIN'?sessionStorage.getItem('loggedUserName'):sessionStorage.getItem('loggedInUserInfo'));
        postWithHeadersResponse(URL_VERSION+'/orderMenu?loggedUser=' + loginUserName + '&yearMonth=' + monthYear + '&access_token=', JSON.stringify([_formData]),
            headers).then((response) => {
            if (response.statusCode!==200) {
                throw Error(response.statusMessage);
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if (res.statusCode === 200) {
                sessionStorage.removeItem('Menu')
                sessionStorage.removeItem('Price')
                this.setState({loading: false});
                _addNotification(res.statusMessage, this);
                console.log('response', res);
                setTimeout(() =>
                (sessionStorage.getItem('ROLE')=='ROLE_ADMIN'?
                this.context.router.history.push('/schoolAdmin/viewOrdersGrid')
                : window.location.replace('/parent')), 2000);
            }
        }).catch(
            (error) => {
                this.setState({loading: false});
                _addNotificationError(error.message, this)
                console.log('Meal order Creation Error', error)
            }
        );
    }

    render() {

        const {width} = this.state;
        const isMobile = width <= 500;
        return (
            <div>
                <NotificationSystem ref="notificationSystem"/>
                <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000   '}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>

                <div className="row" style={{margin: '0'}}>
                    <button onClick={this.props.back.bind(this)} style={{margin: '10px 0'}}
                            className="btn btn-danger btn-sm pull-left "> Back
                    </button>
                    <button onClick={this.openEmailSelect} style={{margin: '10px 0'}}
                            className="btn btn-success btn-sm pull-right "> Submit
                    </button>
                </div>
                <div id="print">
                    <div className="row" style={{margin: '0'}}>
                        <div className="order-meal-header capitalize">
                            <div className="col-sm-4">
                                <p>Name: <span>{this.props.studentData.firstName + ' ' + this.props.studentData.lastName}</span>
                                </p>
                            </div>
                            <div className="col-sm-6">
                                <p>School: <span>{this.props.studentData.schoolName}</span></p>
                            </div>
                            <div className="col-sm-2">
                                <p>Grade: <span>{this.props.studentData.gradeName}</span></p>
                            </div>
                            <div className="col-md-6 col-sm-6"></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="text-center">
                            <h5>{MONTH[this.props.mealMonth.month - 1]} {this.props.mealMonth.year} Order
                                Details
                            </h5></div>
                        
                        
                    </div>
                    
                    <FullCalendar
                        height={700}
                        defaultView={isMobile ? 'listMonth':'month'}
                        defaultDate={new Date(this.props.mealMonth.year, this.props.mealMonth.month - 1, 1)}
                        themeSystem='bootstrap3'
                        header={false}
                        weekends={false}
                        editable={false}
                        resizable={false}
                        eventClick={this.selectEvent}
                        events={this.state.menu}
                        displayEventTime={false}
                        fixedWeekCount={false}
                        // droppable: true, // this allows things to be dropped onto the calendar
                        eventRender={this.eventStyles}
                    />
                    {isMobile ? (<div className="row" style={{margin: '0'}}>
                    <button onClick={this.props.back.bind(this)} style={{margin: '10px 0'}}
                            className="btn btn-danger btn-sm pull-left "> Back
                    </button>
                    <button onClick={this.openEmailSelect} style={{margin: '10px 0'}}
                            className="btn btn-success btn-sm pull-right "> Submit
                    </button>
                </div>):
                    (<div className="col-md-12 text-center">
                        <div className="col-md-6 col-sm-6" style={{padding: '0px'}}>
                            <button onClick={this.props.back.bind(this)}
                                    className="btn btn-danger btn-sm pull-right "> Back
                            </button>
                        </div>
                        <div className="col-md-6 col-sm-6" style={{padding: '0px'}}>
                            <button onClick={this.openEmailSelect} className="btn btn-success btn-sm pull-left "> Submit
                            </button>
                        </div>
                    </div>)}
                </div>
                <div id="myID" className="bottomMenu show">
                    <p className="text-center"
                       style={{color: 'red', fontSize: '12px'}}>Order Amount : <span
                            style={{fontSize: '20px'}}>{currency_symbol()+''+parseFloat(this.props.price).toFixed(2)} </span></p>
                </div>
                <br/>
                <br/>
                <EmailSelect open={this.state.showEmailSelect} 
				title={"Select Email to Send Order Receipt"}
                        emailList={this.state.emailList}
                        onSelectionChange={(idx,type,isSelected)=>{
                            let _emails=this.state.emailList;
                            if(type=='A'){                                     
                             _emails.forEach((itm,i)=>{
                                _emails[i].selected=isSelected;
                             })                                     
                            }else{
                                _emails[idx].selected=isSelected;
                            }
                            this.setState({emailList:_emails})
                        }} 
                        onSubmit={(e)=>{
                            if(!this.state.emailList.some(item=>item.selected)){
                                _addNotificationError("Please select at least once email id.",this);
                                return false;
                            }
                            this.prepareForSave()
                        }} 
                        onCancel={(e)=>{
                            this.closeEmailSelect()
                        }} />
                     
                    <Modal
                        isOpen={this.state.showInstantPayModal}
                        style={customStyles}
                        contentLabel="Activation"
                        ariaHideApp={false}>
                        <div className="row">
                        <div className="col-md-8"><h5 style={{color: 'red'}}>Order Payment</h5></div>
                        <div className="col-md-4 text-right"><h5 style={{color: 'red',fontWeight: 'bolder',fontSize: 'large'}}>{`${currency_symbol()} ${convertTwoDecimalPoint(this.props.price,2)}`}</h5></div>
                        </div>
                            <div className="row">
                                <div className="col-md-12">
                                <InstantPayment {...this}
                                    paidEditPrice={this.props.paidEditPrice||0.00}
                                    lunchBal={this.props.lunchBal} 
                                    fullAmount={this.props.price} 
                                    formData={this.state.formData}
                                    mealMonth={ this.props.mealMonth.year + '' + (('0' + this.props.mealMonth.month).slice(-2))}
                                    onAdminPaymentSubmit={(res)=>{
                                        this.adminInstantPaymentSubmit(res);
                                    }}
                                    onClickCancel={()=>{
                                        this.setState({showInstantPayModal:false})
                                    }}
                                    />
                                </div>
                            </div>
                    </Modal>
            </div>
        );
    }
}

orderedMenu.contextTypes = {
    router: PropTypes.object.isRequired
}

export default orderedMenu;


// WEBPACK FOOTER //
// ./src/components/Parent/OrderMeals/orderedMenu.js